// extracted by mini-css-extract-plugin
export default {"heading":"MediaGalleryPage_heading__YB8U-"};